/**
 * @generated SignedSource<<0604e3f78425700337e1ded3f9b5b1cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateCategorySectionContentfulRelayFragment$data = {
  readonly categories: {
    readonly items: ReadonlyArray<{
      readonly categoryNameExternal: string | null | undefined;
      readonly sys: {
        readonly id: string;
      };
      readonly urlSlug: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly templateTypeCollection: {
    readonly items: ReadonlyArray<{
      readonly sys: {
        readonly id: string;
      };
      readonly templateTypeNameExternal: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "templateCategorySectionContentfulRelayFragment";
};
export type templateCategorySectionContentfulRelayFragment$key = {
  readonly " $data"?: templateCategorySectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateCategorySectionContentfulRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateCategorySectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateTemplateTypeCollection",
      "kind": "LinkedField",
      "name": "templateTypeCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyTemplateType",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateTypeNameExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "categories",
      "args": null,
      "concreteType": "ProductTemplateCategoryCollection",
      "kind": "LinkedField",
      "name": "categoryCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyTemplateCategory",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryNameExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlSlug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "488fa70f5b471114a1118928e06ba1f2";

export default node;
